// It is the only place where we import directly from 'react-redux', in all other files useAppDispatch and useAppSelector
// should be used
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState } from './state/root';
import { AppDispatch } from '@app/store';

// Use throughout app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
